export default "__VITE_ASSET__579b77f4__"